var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19178",
    "data-name": "Group 19178",
    transform: "translate(-230 -1210.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19177",
    "data-name": "Group 19177"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(230 1210.826)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18245",
    "data-name": "Group 18245",
    transform: "translate(-6.688 -0.838)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1462",
    "data-name": "Line 1462",
    x2: 2.302,
    y2: 2.302,
    transform: "translate(238.537 1213.514)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1463",
    "data-name": "Line 1463",
    x1: 2.302,
    y2: 2.302,
    transform: "translate(238.537 1213.514)",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOff);
export default __webpack_public_path__ + "static/media/switchOff.591da6757b67edbc2fb23c1cb8c549df.svg";
export { ForwardRef as ReactComponent };